import { Component, OnInit, ElementRef, Input } from "@angular/core";
import { Router } from "@angular/router";

import { UserService } from "src/app/ui/services/user.service";
import { HeaderService } from "./../../services/header.service";
import { environment } from "src/environments/environment";
import { AuthService } from "../../services/auth.service";
import { RouteStrategyFactory } from "../../gateways/route-strategy-factory";
import { RoutePath } from "../../models/domains/route-paths.model";
import { GeneralReportService } from "../../services/pbm/general-report.service";

@Component({
  selector: "header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @Input() headerTitle: string;

  date = new Date();
  today = this.date.toLocaleDateString("pt-br", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  constructor(
    private authService: AuthService,
    public el: ElementRef,
    private routeStrategyFactory: RouteStrategyFactory,
    private router: Router,
    private headerService: HeaderService,
    private userService: UserService,
    private generalReportService: GeneralReportService,
  ) {}

  ngOnInit(): void {}

  getAppName(): string {
    return environment.appName;
  }

  getTitle(): string {
    return this.headerTitle;
  }

  getVersion(): string {
    return environment.version;
  }

  getDate(): string {
    return this.today;
  }

  getUserName(): string {
    if (this.userService.getLoggedUser()) {
      return this.userService.getLoggedUser().getName();
    }
    return "";
  }

  getUserRole(): string {
    const userRoleList = this.userService.getLoggedUser().getUserRoleList();
    if (userRoleList && userRoleList.length > 0) return userRoleList[0].getName();
    return "";
  }

  logOut(): void {
    this.authService.logout();
    this.generalReportService.clearAllowedCompanies(); //lista do relatório geral
    this.routeStrategyFactory.createStrategy().redirect();
  }

  healthCheck(): void {
    this.router.navigate([RoutePath.HealthCheck]);
  }

  getTitleText(): string {
    return this.headerService.getTitleText();
  }

  getTitleIcon(): string {
    return this.headerService.getTitleIcon();
  }
}
